import React, {Component} from 'react';
import {connect} from 'react-redux'

import { locale } from "../locale/AppLocale";

class Search extends Component {

    render() {
        return (
            <div className="panel-1 products-search">
                <div className="panel-1--head panel-1--head--centered">
                    {  locale.get('what_to_sell') }
                </div>
                {this.props.children}
            </div>
        );
    }
}


// Maps state from store to props
const mapStateToProps = (state, ownProps) => {
    return {
        auth: state.auth,
    }
};

// Maps actions to props
const mapDispatchToProps = (dispatch) => {
    return {
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(Search);